import { Link } from 'react-router-dom';
import { Badge } from '../components/ui/badge';
import { 
  Type, Braces, Palette, Sparkles, Search, Mail, 
  Terminal, ImageDown, Brain, BarChart3, Megaphone, 
  Code2, ListTodo, Image
} from 'lucide-react';

const iconMap = {
  type: Type,
  braces: Braces,
  palette: Palette,
  sparkles: Sparkles,
  search: Search,
  mail: Mail,
  terminal: Terminal,
  'image-down': ImageDown,
  brain: Brain,
  chart: BarChart3,
  megaphone: Megaphone,
  code: Code2,
  task: ListTodo,
  image: Image,
  key: Code2,
  hash: Code2,
  link: Code2,
  fileCode: Code2,
  clock: Code2,
  regex: Code2,
  diff: Code2,
  text: Type,
  number: Code2,
  tag: Code2,
};

const tierColors = {
  free: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  pro: 'bg-primary/20 text-primary border-primary/30',
  business: 'bg-accent/20 text-accent border-accent/30',
};

const ToolCard = ({ tool }) => {
  const IconComponent = iconMap[tool.icon] || Code2;

  return (
    <Link
      to={`/tools/${tool.slug}`}
      className="group relative overflow-hidden rounded-xl border border-white/5 bg-white/5 p-6 hover:border-primary/50 hover:bg-white/10 transition-all duration-500 card-hover"
      data-testid={`tool-card-${tool.slug}`}
    >
      {/* Icon */}
      <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
        <IconComponent className="w-6 h-6 text-primary" />
      </div>

      {/* Content */}
      <h3 className="font-semibold text-lg mb-2 font-['Plus_Jakarta_Sans'] group-hover:text-primary transition-colors">
        {tool.name}
      </h3>
      <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
        {tool.short_description}
      </p>

      {/* Badge */}
      <Badge variant="outline" className={`${tierColors[tool.tier]} capitalize text-xs`}>
        {tool.tier}
      </Badge>

      {/* Hover glow effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/0 via-primary/5 to-primary/0 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
    </Link>
  );
};

export default ToolCard;
